<template>
    <Navbar />
    <v-main class="tw-bg-primary-100">
        <Suspense>
            <router-view />
        </Suspense>
        <Footer />
    </v-main>
</template>

<script setup lang="ts">
    import Navbar from './Layout/Navbar.vue';
    import Footer from './Layout/Footer.vue';
</script>
